
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useSurpriseSetting } from '@/modules/surprise/setting/model/edit';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.SETTING,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useSurpriseSetting();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
